import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import LightModeIcon from '@mui/icons-material/LightMode'
import DarkModeIcon from '@mui/icons-material/DarkMode'
import { useColorScheme } from '@mui/material/styles'

export default function ButtonAppBar() {
  const { mode, systemMode, setMode } = useColorScheme()
  const resolvedMode = (mode === 'system' ? systemMode : mode) ?? 'light'

  return (
    <Box>
      <AppBar position="static" elevation={0}>
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Hetzner Auction UI
          </Typography>
          <IconButton
            size="large"
            edge="end"
            color="inherit"
            aria-label={resolvedMode === 'dark' ? 'switch to light mode' : 'switch to dark mode'}
            onClick={() => setMode(resolvedMode === 'dark' ? 'light' : 'dark')}
          >
            {resolvedMode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
          </IconButton>
        </Toolbar>
      </AppBar>
    </Box>
  )
}
